import React from 'react';

const Footer = () => (
  <footer className="w-full bg-gray-50 border-t border-gray-100 py-4 px-6 flex flex-col md:flex-row items-center justify-between text-sm text-gray-500">
    <div className="flex items-center gap-3 mb-2 md:mb-0">
      <span>© 2025</span>
      <span className="mx-2">•</span>
      <a href="https://sprinto.com/terms/?_gl=1*1i9u419*_gcl_au*MTg2NjE5NDAwOC4xNzUxMTk3NzY1LjIwODIzMjMwNzYuMTc1MTIwNzU5Mi4xNzUxMjA3NTkx" target="_blank" rel="noopener noreferrer" className="hover:underline">Terms & Conditions</a>
      <span className="mx-2">•</span>
      <a href="https://sprinto.com/privacy/?_gl=1*1i9u419*_gcl_au*MTg2NjE5NDAwOC4xNzUxMTk3NzY1LjIwODIzMjMwNzYuMTc1MTIwNzU5Mi4xNzUxMjA3NTkx" target="_blank" rel="noopener noreferrer" className="hover:underline">Privacy Policy</a>
    </div>
    <div className="flex items-center gap-2">
      <span>Security compliance, made easy with</span>
      <img src="/sprinto-logo.png" alt="Sprinto Logo" className="h-6 w-6 rounded bg-black" style={{ objectFit: 'contain' }} />
      <span className="font-semibold text-[#22336c] tracking-wide text-base ml-1">SPRINTO</span>
    </div>
  </footer>
);

export default Footer; 